import { useContext } from 'react';

import { ConfigContext, ConfigProvider } from './ConfigProvider';
import type { ConfigOptions, ConfigUtils } from './types';

const useConfig = () => useContext(ConfigContext);

export { type ConfigOptions, type ConfigUtils, ConfigProvider, useConfig };
